import React, { FC, ReactNode, useCallback, useState } from "react";
import cn from "clsx";
import { useOutsideEventDetector } from "@/hooks";
import FilterOptionsContainer from "./filterOptionsContainer";

type FilterElementProps = {
  className?: string;
  children: ReactNode;
  filterLabel?: string;
  filterSelectedCount?: string | number;
  filterWrapperClassName?: string;
  setSearchValue?: (value: string) => void;
  onClose?: () => void;
  onOpen?: () => void;
};

const FilterElement: FC<FilterElementProps> = ({
  className,
  children,
  filterLabel,
  filterSelectedCount,
  filterWrapperClassName,
  setSearchValue,
  onClose,
  onOpen
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const outsideEvents = filterWrapperClassName?.includes("size_chart_wrapper")
    ? ["click", "touchstart"]
    : ["click", "touchstart", "scroll"];
  const clickOutsideDetectorRef = useOutsideEventDetector<HTMLHeadingElement>(
    () => {
      setSearchValue && setSearchValue("");
      setIsOpen(false);
      onClose?.();
    },
    outsideEvents
  );
  const onClickHandler = useCallback(
    (e: React.MouseEvent) => {
      setIsOpen(prev => {
        const next = !prev;
        if (!prev && next) {
          onOpen?.();
        }
        if (prev && !next) {
          onClose?.();
        }
        return next;
      });
    },
    [onClose, onOpen]
  );

  return (
    <h4
      className={cn(
        className,
        "filter_title",
        isOpen ? "filter_open" : "filter_close_inner"
      )}
      onClick={onClickHandler}
      ref={clickOutsideDetectorRef}
    >
      <span>
        {!!filterLabel && filterLabel}
        {!!filterSelectedCount && <strong>[{filterSelectedCount}]</strong>}
      </span>
      {isOpen && (
        <FilterOptionsContainer filterWrapperClassName={filterWrapperClassName}>
          {children}
        </FilterOptionsContainer>
      )}
    </h4>
  );
};

export default FilterElement;
